import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";
import AudioFile from "../components/AudioFile.jsx";
import { ServiceLink } from "../components/ServiceLink.jsx";
import { Voicemail } from "../components/Voicemail.jsx";
import DestinationGroup from "../components/DestinationGroup.jsx";
import * as CONSTANTS from "../constants";

export default class OutOfHours extends React.Component {
  abortController = new AbortController();

  constructor(props, context) {
    super(props, context);
    this.state = {
      preset: null,
      divertAudio: null,
      divertService: null,
    };
  }

  componentDidMount = () => {
    if (this.props.module.presetId) {
      // load the preset
      fetch(
        `/services/view_date_preset_json?datePresetId=${this.props.module.presetId}`,
        {
          headers: {
            "content-type": "application/json",
          },
          method: "GET",
          cache: "no-cache",
          signal: this.abortController.signal,
        },
      )
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((preset) => {
          const stringResponse = preset.response.getResponse;
          const datePreset = stringResponse;
          this.setState({ preset: datePreset });
        });
    }
  };

  componentWillUnmount = () => {
    this.abortController.abort();
  };

  render() {
    const { module } = this.props;

    return (
      <SummaryItem itemKey={"Out of Hours: "}>
        <SectionItem itemKey="Divert Calls to">
          {CONSTANTS.callType[module.callTypeId]}
        </SectionItem>
        {module.callTypeId === 1 && (
          <SectionItem itemKey="Divert Number">
            <DestinationGroup
              group={module}
              sites={this.props.sites}
              clientId={this.props.clientId}
            />
          </SectionItem>
        )}
        {module.callTypeId === 5 && (
          <SectionItem itemKey="Divert Audio">
            <AudioFile audioId={module.audio} />
          </SectionItem>
        )}
        {module.callTypeId === 8 && (
          <SectionItem itemKey="Divert Service">
            <ServiceLink service={module.linkedModuleGroup} />
          </SectionItem>
        )}
        {module.callTypeId === 7 && <Voicemail config={module} />}
      </SummaryItem>
    );
  }
}
OutOfHours.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
